import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12.5 6.002c0 2.584-3 6.828-4.101 8.297a.497.497 0 01-.798 0C6.501 12.83 3.5 8.586 3.5 6.002a4.5 4.5 0 119 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.166 6a2.167 2.167 0 11-4.333 0 2.167 2.167 0 014.333 0z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 9.003c0 3.876-4.501 10.242-6.152 12.446-.299.4-.897.4-1.196 0-1.651-2.204-6.152-8.57-6.152-12.446a6.75 6.75 0 1113.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 9a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 18.006c0 7.752-9.002 20.484-12.304 24.892-.598.8-1.794.8-2.392 0C19.502 38.49 10.5 25.758 10.5 18.006c0-7.456 6.044-13.5 13.5-13.5s13.5 6.044 13.5 13.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.5 18a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z",
    clipRule: "evenodd"
  }))
};
export var LocationPin = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});